import React, { useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import API from "../../Common/API"
import Button from "../../Components/Button"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { setAlert } from '../../Store/Theme/actions'

const initialAddform = {
    name: '',
    mobileNumber: '',
    alternateMobile: '',
    defaultAddress: false,
    addedBy: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    district: '',
    pinCode: '',
    landMark: '',
}
const CreateAddress = () => {


    const history = useHistory()
    const dispatch = useDispatch()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const userDetails = useSelector((state) => state.auth.userDetails)

    const addressFormSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        mobileNumber: Yup.string().required("Mobile number is required"),
        alternateMobile: Yup.string().nullable(),
        defaultAddress: Yup.boolean(),
        addressLine1: Yup.string().required("Address Line1 is requried"),
        addressLine2: Yup.string().nullable(),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        district: Yup.string().required("District is required"),
        pinCode: Yup.string().required("PinCode is required"),
        landMark: Yup.string().nullable(),
    })

    const addressForm = useFormik({
        initialValues: initialAddform,
        validateOnMount: true,
        validationSchema: addressFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setSubmitDisabled(true)
            values.addedBy = userDetails.subject._id
            API.post('/users/addDeliveryAddress', values).then((addRes) => {
                if (addRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Address added successfully', active: true, type: 'success' }))
                    history.goBack()
                }
            }).catch((err) => {
                dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
            })
        }
    })

    const getLocation = (values) => {
        if (values.length === 6) {
            API.post('/common/getLocationByCode', { pinCode: values }).then((res) => {
                if (res.status === 200) {
                    const place = res.data.data
                    addressForm.setValues({ ...addressForm.values, city: place.city, district: place.district, state: place.state })
                }
            })
        } else {
            addressForm.setValues({ ...addressForm.values, city: '', district: '', state: '' })
        }
    }
    return (
        <motion.div className="h-full w-full flex flex-col items-center py-5 px-20">
            <motion.div className="text-md font-bold">
                Add Address
            </motion.div>
            <motion.div className="grid grid-cols-1 w-96 px-5 py-2">
                <FieldInput label={'Name'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('name')} fieldMeta={addressForm.getFieldMeta('name')} fieldProps={addressForm.getFieldProps('name')} edit={true} dataLoaded={true} />
                <FieldInput type={'phone'} label={'Mobile Number'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('mobileNumber')} fieldMeta={addressForm.getFieldMeta('mobileNumber')} fieldProps={addressForm.getFieldProps('mobileNumber')} edit={true} dataLoaded={true} />
                <FieldInput type={'phone'} label={'Alternate Mobile Number'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('alternateMobile')} fieldMeta={addressForm.getFieldMeta('alternateMobile')} fieldProps={addressForm.getFieldProps('alternateMobile')} edit={true} dataLoaded={true} />
                <FieldInput label={'Pincode'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('pinCode')} fieldMeta={addressForm.getFieldMeta('pinCode')} fieldProps={addressForm.getFieldProps('pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                <FieldInput label={'Address Line 1'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('addressLine1')} fieldMeta={addressForm.getFieldMeta('addressLine1')} fieldProps={addressForm.getFieldProps('addressLine1')} edit={true} dataLoaded={true} />
                <FieldInput label={'Address Line 2'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('addressLine2')} fieldMeta={addressForm.getFieldMeta('addressLine2')} fieldProps={addressForm.getFieldProps('addressLine2')} edit={true} dataLoaded={true} />
                <FieldInput label={'City'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('city')} fieldMeta={addressForm.getFieldMeta('city')} fieldProps={addressForm.getFieldProps('city')} edit={true} dataLoaded={true} />
                <FieldInput label={'District'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('district')} fieldMeta={addressForm.getFieldMeta('district')} fieldProps={addressForm.getFieldProps('district')} edit={true} dataLoaded={true} />
                <FieldInput label={'State'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('state')} fieldMeta={addressForm.getFieldMeta('state')} fieldProps={addressForm.getFieldProps('state')} edit={true} dataLoaded={true} />
                <FieldInput label={'Land Mark'} placeholder={'Optional'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('landMark')} fieldMeta={addressForm.getFieldMeta('landMark')} fieldProps={addressForm.getFieldProps('landMark')} edit={true} dataLoaded={true} />
                <motion.div className="flex px-5 flex-row w-full items-center">
                    <input type="checkbox" value={addressForm.values.defaultAddress} checked={addressForm.values.defaultAddress} onChange={(ev) => { addressForm.setValues({ ...addressForm.values, defaultAddress: ev.target.checked }) }}></input>&nbsp;<p>Mark as default address</p>
                </motion.div>
                <motion.div className="w-full my-10 flex flex-row justify-between">
                    <Button injectClass={'bg-[red]/20 rounded-md ring-[red] cursor-pointer'} onClick={() => { history.goBack(); addressForm.resetForm() }}>Cancel</Button>
                    <Button injectClass={`bg-[green]/20 rounded-md ring-[green] ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => !submitDisabled && addressForm.submitForm()}>Save</Button>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default CreateAddress